import { useNavigate } from "react-router-dom";
import { Modal, ModalContent, ModalFooter } from "../../components/Modal";
import { aspetto_logo } from "../../constant/_constant";
import { useState, useEffect } from "react";

const SuccessModal = ({ isOpen = true, onClose }) => {
  const [open, setOpen] = useState(isOpen);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    } else {
      navigate("/"); // default redirect
    }
  };

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  return (
    <Modal isOpen={open}>
      <ModalContent>
        <div className="text-center w-50 mb-3 m-auto">
          <img src={aspetto_logo} height={80} alt="aspetto_logo" />
        </div>
        <h2 className="h3 text-center mb-3">Card Linked Successfully</h2>
        <p className="text-center text-success">
          Your card has been securely linked to your account.
        </p>
        {/* <p className="text-center">
          You're all set! You can now proceed with transactions.
        </p> */}
      </ModalContent>
    </Modal>
  );
};

export default SuccessModal;
